export default __webpack_public_path__ + "static/media/logo-brand.228bb3c9.png";